<script lang="ts" setup>
interface Props {
  show?: boolean
  wide?: boolean
  redirect?: () => void
  fixed?: boolean
}

withDefaults(defineProps<Props>(), {
  fixed: true,
})

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>
<template>
  <Transition
    as="template"
    enter="ease-out duration-300"
    enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    enter-to="opacity-100 translate-y-0 sm:scale-100"
    leave="ease-in duration-200"
    leave-from="opacity-100 translate-y-0 sm:scale-100"
    leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  >
    <div
      v-show="show"
      class="z-20 overflow-y-auto m-2 bg-white border border-neutral-300 dark:border-neutral-500 dark:bg-neutral-900/80 backdrop-blur-sm backdrop-filter rounded-lg text-left xxxoverflow-hidden drop-shadow-lg/30 dark:drop-shadow-lg/60 transform transition-all"
      :class="[
        wide ? 'max-w-sm sm:max-w-lg w-full' : 'sm:w-full sm:max-w-sm',
        fixed ? 'fixed' : '',
      ]"
    >
      <div>
        <slot />
      </div>

      <slot name="footer" />
    </div>
  </Transition>
</template>
